module.exports = __webpack_public_path__ + "static/media/eco-ecology-hand-svgrepo-com.cf995df8.svg";